module.exports = __webpack_public_path__ + "media/lookbook_0.d9576cb2.mp4";